import type { TKey } from '@/lib/i18n'
import { AppBadges } from './app-badges'

/**
 * Presentational layout shared by the feature landing pages (scanner, deck
 * builder, collection tracker). Reuses the public-site CSS classes; each route
 * passes already-translated copy so translation keys stay statically typed.
 */
export function FeatureLanding(props: {
	t: (key: TKey) => string
	eyebrow: string
	title: string
	lead: string
	features: Array<{ title: string; body: string }>
	ctaTitle: string
	ctaSubtitle: string
}) {
	return (
		<>
			<section className='hero'>
				<div className='wrap'>
					<span className='eyebrow'>{props.eyebrow}</span>
					<h1>{props.title}</h1>
					<p className='lead'>{props.lead}</p>
					<div className='hero-actions'>
						<AppBadges t={props.t} />
					</div>
				</div>
			</section>

			<section className='section'>
				<div className='wrap'>
					<div className='features'>
						{props.features.map((feature) => (
							<div className='feat' key={feature.title}>
								<h3>{feature.title}</h3>
								<p>{feature.body}</p>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className='section' style={{ paddingTop: '32px' }}>
				<div className='wrap'>
					<div className='cta-band'>
						<h2>{props.ctaTitle}</h2>
						<p>{props.ctaSubtitle}</p>
						<div className='badges'>
							<AppBadges t={props.t} />
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
